import {
    FETCH_TEMPLATE_CONTENT_REQUEST,
      FETCH_TEMPLATE_CONTENT_SUCCESS,
      FETCH_TEMPLATE_CONTENT_FAILURE,
    } from "./FetchTemplateContentTypes";
    import api from "../../utils/Api";
    
    export const fetchTemplateContentRequest = () => {
      return {
        type: FETCH_TEMPLATE_CONTENT_REQUEST,
      };
    };
    
    export const fetchTemplateContentSuccess = (templateContent) => {
      return {
        type: FETCH_TEMPLATE_CONTENT_SUCCESS,
        payload: templateContent,
      };
    };
    
    export const fetchTemplateContentFailure = (error) => {
      return {
        type: FETCH_TEMPLATE_CONTENT_FAILURE,
        payload: error,
      };
    };
    
    export const fetchTemplateContent = (lk_template_id) => {
    
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "template/fetch?";
      if(lk_template_id){
        url += "lk_template_id=" + lk_template_id;
      }    
      
      return async (dispatch) => {
        dispatch(fetchTemplateContentRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const templateContent = response.data.data;
          dispatch(fetchTemplateContentSuccess(templateContent));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchTemplateContentFailure(errorMsg));
        }
      };
    };
    